export default "__VITE_ASSET__2f2adf65__"